import { useInjection } from 'inversify-react';
import { EGlobalDIKeys } from 'core/di/keys';
import { IHistoryStackObserver } from './types';

export const useHistoryStackObserver = () => {
  return useInjection<IHistoryStackObserver>(EGlobalDIKeys.HistoryStack);
};
